
/**
 * @description 导出通用配置
 */
module.exports = {
    title: '创培课堂后台',
    technicalSupport: '© 2020 德伦教育科技有限公司 技术支持',
    page :1,
    page_size :30,
    total :0
}